import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Utils/axiosInstance";
import { toast } from "react-hot-toast";

const initialStateGateway = {
    settings: null,
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getGatewaySettings = createAsyncThunk(
    "gateway/getGatewaySettings",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/gateway/settings`);
            return response.data.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const updateGatewaySettings = createAsyncThunk(
    "gateway/updateGatewaySettings",
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/gateway/settings`, data);
            toast.success(response.data.message || "AI Blog settings updated successfully");
            return response.data.data;
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "Failed to update AI Blog settings");
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const gatewaySlice = createSlice({
    name: 'gateway',
    initialState: initialStateGateway,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getGatewaySettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(getGatewaySettings.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.settings = action.payload;
            })
            .addCase(getGatewaySettings.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch settings';
            })
            .addCase(updateGatewaySettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateGatewaySettings.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.settings = action.payload;
            })
            .addCase(updateGatewaySettings.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update settings';
            });
    },
});

export default gatewaySlice.reducer;
